var _defs, _g, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeachBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "beach_x5F_ball",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 704.3 706",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st2 {\n        display: none;\n        fill: #fff;\n      }\n\n      .st3 {\n        fill: url(#radial-gradient);\n      }\n\n      .st4 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 300,
    cy: 296.4,
    fx: 300,
    fy: 296.4,
    r: 617.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 299.5,
    y1: 242.6,
    x2: 646.4,
    y2: 579.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bc741e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 150.4,
    y1: 73.2,
    x2: 468.3,
    y2: 73.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#29abe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fdaff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 10.6,
    y1: 421.7,
    x2: 127.5,
    y2: 395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1272d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7bac"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 352.2,
    cy: 353.8,
    r: 352.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M511.5,252.8c-130.7-42.7-209.1-49.6-239.4-50.4.2,19.6-5.6,40.7-17.6,60.1-9.2,14.8-20.9,26.7-33.8,35.3,14.7,35.9,47.1,109,98.7,195.5,71.6,129.2,173.1,184.8,173.1,184.8,0,0,103.9-46.9,152.9-126.1,49.1-79.3,59-171.9,59-171.9,0,0-40.8-77.5-192.8-127.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304.9,4.8c-89.1,15-145.2,53.5-145.2,53.5,0,0-9.3,17.8-9.3,36.3s8.1,47.8,9.2,51.7c22.9-15.2,49.4-19.7,71.6-10.8,8.6-8.1,59-55,93.8-77.1,58.6-37.1,143.3-37.1,143.3-37.1,0,0-81.8-33.5-163.5-16.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85,371.2c11.8-42.5,26.1-70.4,35.2-85.3-12.2-18.3-15.7-43.2-9.8-68.6-10.4,1.2-30.5,4.3-50.2,10.7-28.3,9.3-45.7,25.1-45.7,25.1,0,0-25.9,68.3-8,168.9,15.4,87,81.7,165.1,81.7,165.1,0,0-45.1-64.9-3.3-215.9Z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 160.7,
    cy: 249.1,
    rx: 96.4,
    ry: 76.1,
    transform: "translate(-135.7 253.9) rotate(-58.1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeachBall);
export default __webpack_public_path__ + "static/media/beach-ball.42e7fa2f75bf695ab02083a1fcc007cd.svg";
export { ForwardRef as ReactComponent };